import { useState, useEffect } from "react"
import TableStyle from "components/Options/TableStyle"
import { useSelector, useDispatch } from "react-redux"
import {
    scheduledPickupColor,
    onDockColor,
    makeNiceDate,
} from "../helpers"
import { isBusABusByNamingConvention } from "components/Orders/helpers"
import { Collapse } from "reactstrap"
import OrderRow from "./order"
import { LabelPrinter } from "../modals/LabelPrint"
import { BusLoadUnloadUtility } from "../modals/LoadConfirmation"
import { BOLPrinter } from "../modals/PrintBOL"
import PartialRow from "./partial"
import BlankSpace from "components/UI/Atoms/BlankCell"


export const BusTypeRowSignal = () => (
    <span
        className="badge row-type-signal-badge bus"
        style={{ fontWeight: "bold" }}>
        B
    </span>
)

export const getBusWeight = (bus) => {
    const ordersWeight = bus.orders.reduce((acc, order) => acc + order.weight, 0)
    const partialsWeight = bus.partials.reduce((acc, partial) => acc + partial.weight, 0)
    return ordersWeight + partialsWeight
}

const BusRow = ({ bus }) => {
    const dispatch = useDispatch()


    const display = useSelector((state) => state.warehouse.display)
    const selectedRows = useSelector((state) => state.warehouse.selectedRows)
    const warehouse = useSelector((state) => state.warehouse.warehouse)
    const [ordersRowExpanded, setExpanded] = useState(false)

    return (
        <>
            <tr
                key={`bus-tr-${bus.id}`}
                className={`bus-row bus-class-${isBusABusByNamingConvention(bus)}`}
                style={{
                    cursor: "pointer",
                    borderLeft: "2px solid rgb(67, 0, 145)",
                }}
            >
                {display === "Incoming" && (
                    <td
                        className="inbound-column "
                    >
                        <div style={{ width: '100%' }} className="d-flex justify-content-between">
                            <div className="flex-column">
                                {bus.name} | {bus.driver}
                            </div>
                            <div className="flex-column">
                                <BusTypeRowSignal />
                            </div>
                        </div>
                    </td>
                )}
                {display === "Incoming" && warehouse === "Laredo" && (
                    <td className="trailer-column">{bus.master_trailer_placas}</td>
                )}
                <td
                    className="dock-column"
                    style={
                        (display === "Incoming" & bus.dock)
                            ? onDockColor(bus.dock)
                            : undefined
                    }
                >
                    <span
                        className={TableStyle.GetStatusClasses(bus)}
                    >
                        {bus.dock}
                    </span>
                </td>
                <td
                    className="order-number-column"
                    onClick={() => {
                        setExpanded(!ordersRowExpanded)
                    }}
                >
                    {`${bus.orders.length + bus.partials.length} Orders On The Bus`}
                    {/* {row.orders.map((order) => (
                        <div>
                            {order.order_no} {order.order_group} {order.pro_f}
                        </div>
                    ))} */}
                </td>
                {display === "Outgoing" && (
                    <td
                        className={`trailer-number-column` + (bus.name == 0 ? "cred" : "")}
                        onClick={() => {
                            setExpanded(!ordersRowExpanded)
                        }}
                    >

                        <div style={{ width: '100%' }} className="d-flex justify-content-between">
                            <div className="flex-column">
                                {bus.name}
                                {bus.driver ? " / " + bus.driver : ""}
                                {bus.trailer_number && (
                                    <span
                                        className="text-danger text-uppercase font-weight-bold"
                                    >
                                        {` | ${bus.trailer_number}`}
                                    </span>
                                )}
                            </div>
                            <div className="flex-column">
                                <BusTypeRowSignal />
                            </div>
                        </div>
                    </td>
                )}
                <td
                    className="deliver-to-column"
                >
                    <div>
                        <span><BlankSpace /></span>
                    </div>
                </td>
                {display === "Outgoing" ? (
                    <td
                        className="scheduled-pickup-column"
                        style={scheduledPickupColor(bus.scheduled_pickup)}
                    >
                        {bus.scheduled_pickup
                            ? makeNiceDate(bus.scheduled_pickup)
                            : ""}
                    </td>
                ) : (
                    <></>
                )}
                <td
                    className="skid-column"
                >
                    <>
                        {bus.skids}
                    </>
                    {display === "Outgoing" ? (
                        bus.skid_match_outgoing === true ? (
                            <>
                                <i
                                    className='fa fa-check'
                                    style={{ color: "green" }}
                                />
                            </>
                        ) : bus.skid_match_outgoing === false ? (
                            <>
                                <i
                                    className='fa fa-exclamation'
                                    style={{ color: "red" }}
                                />
                            </>
                        ) : (
                            ""
                        )
                    ) : bus.skid_match_incoming === true ? (
                        <>
                            <i
                                className='fa fa-check'
                                style={{ color: "green" }}
                            />
                        </>
                    ) : bus.skid_match_incoming === false ? (
                        <>
                            <i
                                className='fa fa-exclamation'
                                style={{ color: "red" }}
                            />
                        </>
                    ) : (
                        ""
                    )}
                </td>
                <td
                    className="weight-column"
                >
                    {getBusWeight(bus)}
                </td>
                <td
                    className={`actions-column-${display.toLowerCase()}`}
                >
                    <LabelPrinter orders={bus.orders} />
                    {display === "Outgoing" && (
                        <>
                            <BOLPrinter bus={bus} />
                        </>
                    )}
                    <BusLoadUnloadUtility bus={bus} />
                </td>
                <td
                    className="notes-column"
                >
                    <div className="d-flex flex-row justify-content-between">
                        <div
                            style={{
                                textDecoration: "underline",
                                // fontWeight: "bold",
                            }}
                            className="flex-column"
                        >
                            {bus.pieces_left}
                        </div>
                        <div className="flex-column justify-content-end">
                            <button
                                className="btn-xs action-btn btn-collapse"
                                title="Toggle Members"
                                onClick={() => {
                                    setExpanded(!ordersRowExpanded)
                                }}
                            >
                                {ordersRowExpanded ? (
                                    <i className="fa fa-chevron-up"></i>
                                ) : (
                                    <i className="fa fa-chevron-down"></i>
                                )}
                            </button>
                        </div>

                    </div>
                </td>
            </tr >
            <tr
                className="warehouse-bus-orders-row border"
            >
                <td
                    className="border-0 p-0 m-0"
                    colSpan={(warehouse === "Laredo" | display == "Outgoing") ? '9' : '8'}
                    style={{
                        cursor: "pointer",
                    }}
                >
                    <Collapse isOpen={ordersRowExpanded}>
                        <table
                            style={{
                                borderLeft: "2px solid rgb(67, 0, 145)",
                                borderRadius: "12px",
                                // borderBottom: "3px solid rgb(67, 0, 145)",
                                // marginBottom: "10px",
                                overflow: "show",
                            }}
                            className="w-100"
                        >
                            <tbody>
                                {bus.partials.map((partial) => (
                                    <PartialRow
                                        key={`partial-${partial.id}`}
                                        partial={partial}
                                    />
                                ))}
                                {bus.orders.map((order) => (
                                    <OrderRow
                                        key={`order-${order.id}`}
                                        order={order}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </Collapse>
                </td>
            </tr>
        </>
    )
}

export default BusRow
